import type { LocaleCode, LocaleSearchParams } from "../types";

import { getLocaleRegistry } from "../registry/locale-registry";

function getSearchParam(
  searchParams: LocaleSearchParams | null | undefined,
  key: string,
): string | null {
  if (!searchParams) {
    return null;
  }

  if (searchParams instanceof URLSearchParams) {
    return searchParams.get(key);
  }

  return searchParams.get(key) ?? null;
}

function resolveLocaleCodeFromQuery(
  searchParams: LocaleSearchParams | null | undefined,
): LocaleCode | null {
  const value = getSearchParam(searchParams, "locale")?.trim().toLowerCase();

  if (!value) {
    return null;
  }

  const registry = getLocaleRegistry();

  if (value in registry) {
    return value as LocaleCode;
  }

  return null;
}

export { resolveLocaleCodeFromQuery };
